import React from 'react';
import PropTypes from 'prop-types';
import Terms from '../../../pages/Terms/Terms.jsx';

const TermsView = ({ open, onAgree, onCancel }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 px-4">
      <div className="bg-pl_bg_light_3 text-pl_txt_light_1 p-4 md:p-5 rounded-2xl shadow-xl border w-[100%] max-w-[1200px] h-[450px] overflow-y-auto">

        <div className=" p-3">
          <Terms sectionOnly={7}/>
        </div>
        <div className="flex justify-center gap-8 ">
          <button
            className="px-8 py-1 rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="px-8 py-1 rounded-full bg-pl_prim_color_1 text-white hover:bg-pl_prim_color_2"
            onClick={onAgree}
          >
            Agree
          </button>
        </div>
      </div>
    </div>
  );
};

TermsView.propTypes = {
  open: PropTypes.bool.isRequired,
  onAgree: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default TermsView;
